import { AuthService } from './../../../services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Responsible } from '../../../models/responsible';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-responsible-view',
  templateUrl: './responsible-view.component.html',
  styleUrls: ['./responsible-view.component.css']
})
export class ResponsibleViewComponent implements OnInit {

  responsible: Responsible;
  clients: any[];
  schools: any[];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  isAccountPage: boolean;
  pack: Array<Select2OptionData>;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
  ) {
    this.responsible = new Responsible();
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.isAccountPage = (this.router.url.indexOf('/account') === 0);
    this.route.params.subscribe(params => {
      const id = this.isAccountPage ? this.authService.getUser().id : params['id'];
      this.http.get(
        '/api/responsible/' + id
      ).subscribe((responsible: Responsible) => {
        this.responsible = responsible;
        this.pack = this.pack.map((data, index) => {
          return {
            id: data.id,
            text: data.text,
            selected: (data.id == responsible.pack) ? true : false
           };
        });

        this.http.get(
          '/api/client/lookup'
        ).subscribe((clients: any[]) => {
          this.clients = clients;
          const array1 = [{ id: '', text: 'Choisir un client' }];
          const array2 = this.clients.map((client, index) => {
            return { id: client.id, text: client.name, selected: (client.id == this.responsible.School.clientId) ? true : false };
          });
          this.clientsData = array1.concat(array2);
        });
      });
    });
  }

  ngOnInit() {
  }

  clientChanged(e: any) {
    const params = new HttpParams({
      fromObject: {
        clientId: e.value + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = schools.map((school, index) => {
        return { id: school.id, text: school.name, selected: (school.id == this.responsible.schoolId) ? true : false };
      });
      this.schoolsData = array1.concat(array2);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/responsible/responsible-view/responsible-view.component.ts